"use client";
import React, { useEffect } from "react";
import { Button, FontIcon } from "@/app/_components";
import {SDialogFC, SDialogProps} from "@/Master/SDialogFC/SDialogFC";
import {SDialogManagerFC} from "@/Master/SDialogFC/SDialogManagerFC";
import {ShopItemsListResponse} from "@/app/_api/types/store";
import {openPaymentAsync} from "@/app/(pages)/paymentItemsAPI";
import {ShopItem} from "@/app/_api/types/store";
import styles from "./firstChargeGiftPack.module.css";

interface FirstChargeGiftPackDialogProps extends SDialogProps {
    shopItemsStarterData: ShopItemsListResponse;
    userId: number;
    dispatcher: any;
}

export const FirstChargeGiftPackDialogFC: React.FC<FirstChargeGiftPackDialogProps> = (props) => {
    const { fcKey, isOpen, shopItemsStarterData, userId, dispatcher } = props;
    const dataList = [...shopItemsStarterData].sort((a, b) => b.money - a.money);

    useEffect(() => {
        console.log("FirstChargeGiftPackDialog initialized")

        return () => {
            console.log("FirstChargeGiftPackDialog disposed");
        };
    }, []);

    if (!isOpen) return null;

    const onClose = () => {
        SDialogManagerFC.closeDialog(fcKey);
    };

    const handleStarterPackClick = (item: ShopItem) => {
        const params = {
            userId,
            ...item,
        }
        // 调起支付
        dispatcher(openPaymentAsync(params));
    }

    return (
        <SDialogFC
            fcKey={fcKey}
            isOpen={isOpen}
            mode="Full"
            title=""
            buttons={[
                {
                    label: "Add Now",
                    onClick: () => console.log(1111),
                    style: "greenBtn",
                },
            ]}
            onClose={onClose}
        >
            <section className={`${styles.layer}`}>
                <section className={styles.content}>
                    <section className={styles.font_section}>
                        <div className={styles.close_box} onClick={onClose}>
                            <FontIcon icon="s-close" />
                        </div>
                        <h1>STARTER PACK</h1>
                        <h6>SC comes with your GC purchase as free bonus.</h6>
                    </section>

                    {dataList[0] && <section className={styles.first_gift_section}>
                        <div className={styles.score}>
                            <div className={styles.score_text}>
                                <div>
                                    <span style={{fontWeight: "bold"}}>{dataList[0].gcDiscount*100}</span>%
                                </div>
                                <div style={{fontSize: ".3rem", fontWeight: "bold"}}>OFF</div>
                            </div>
                        </div>
                        <div className={styles.vip_label}>
                            <img style={{width: "0.5rem", verticalAlign: "text-top"}} src="/img/img_vip.webp" alt=""/>
                            <span>VIP +{dataList[0].vipExperience}</span>
                        </div>
                        <div className={styles.first_content}>
                            <div className={styles.gift_box}></div>
                            <div className={styles.textarea} style={{paddingTop: ".15rem"}}>
                                <div className={styles.gc_text}>
                                    <img
                                        src="/img/ico_gc.png"
                                        style={{
                                            width: ".65rem",
                                            marginRight: ".1rem",
                                            verticalAlign: "-0.05rem"
                                        }}
                                        alt=""/>
                                    <span>GC</span>
                                    <span>{dataList[0].gc}</span>
                                </div>
                                <div className={styles.sc_text}>
                                    <span style={{color: "#fff", fontSize: ".6rem", marginLeft: "-0.2rem"}}>+</span>
                                    <img
                                        src="/img/ico_sc.png"
                                        style={{width: ".65rem", verticalAlign: "text-top", margin: "0 .1rem"}}
                                        alt=""
                                    />
                                    {dataList[0].extraScLimit === 0 ?
                                        <span>SC {dataList[0].sc}</span>
                                        :
                                        <span>SC {dataList[0].sc}-SC {dataList[0].sc + dataList[0].extraScLimit}</span>
                                    }
                                    {/*<span>SC </span>*/}
                                    {/*<span>6-SC 8</span>*/}
                                </div>
                                <div style={{padding: ".25rem"}}>
                                    <Button
                                        color="#33D24A"
                                        style={{
                                            color: "#fff",
                                            fontSize: ".6rem",
                                            width: "5.1rem",
                                            height: "1rem",
                                            fontWeight: "bold",
                                        }}
                                        onClick={() => handleStarterPackClick(dataList[0])}
                                    >
                                        Only ${dataList[0].money}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </section>}

                    <section className={styles.or_text}>OR</section>

                    {/* 第二部分 */}
                    {dataList[1] && <section className={styles.second_gift_section}>
                        <section className={`${styles.content} ${styles.second_content}`}>
                            <div className={`${styles.score} ${styles.second_score}`}>
                                <div className={styles.score_text}>
                                    <div>
                                        <span style={{fontWeight: "bold"}}>{dataList[1].gcDiscount*100}</span>%
                                    </div>
                                    <div style={{fontSize: ".3rem", fontWeight: "bold"}}>OFF</div>
                                </div>
                            </div>
                            <div className={styles.vip_label}>
                                <img style={{width: "0.5rem", verticalAlign: "text-top"}} src="/img/img_vip.webp" alt=""/>
                                <span>VIP +{dataList[1].vipExperience}</span>
                            </div>
                            <div className={`${styles.textarea} ${styles.second_textarea}`}>
                                <div className={styles.gc_text}>
                                    <img src="/img/ico_gc.png" style={{width: ".65rem"}} alt=""/>
                                    <span>GC</span>
                                    <span>{dataList[1].gc}</span>
                                </div>
                                <div className={styles.sc_text}>
                                    <span style={{color: "#fff", fontSize: ".6rem", marginLeft: "-0.2rem"}}>+</span>
                                    <img
                                        src="/img/ico_sc.png"
                                        style={{width: ".65rem", verticalAlign: "text-top", margin: "0 .1rem"}}
                                        alt=""
                                    />
                                    {dataList[1].extraScLimit === 0 ?
                                        <span>SC {dataList[1].sc}</span>
                                        :
                                        <span>SC {dataList[1].sc}-SC {dataList[1].sc + dataList[1].extraScLimit}</span>
                                    }
                                    {/*<span>SC</span>*/}
                                    {/*<span>6-SC 8</span>*/}
                                </div>
                                <div style={{padding: ".1rem"}}>
                                    <Button
                                        color="#33D24A"
                                        style={{
                                            color: "#fff",
                                            fontSize: ".6rem",
                                            width: "5.1rem",
                                            height: "1rem",
                                            fontWeight: "bold",
                                        }}
                                        onClick={() => handleStarterPackClick(dataList[1])}
                                    >
                                        Only ${dataList[1].money}
                                    </Button>
                                </div>
                            </div>
                        </section>
                    </section>}

                    <section className={styles.or_text}>OR</section>

                    {/* 第三部分 */}
                    {dataList[2] && <section className={styles.third_gift_section}>
                        <section className={`${styles.content} ${styles.third_content}`}>
                            <div className={`${styles.score} ${styles.third_score}`}>
                                <div className={styles.score_text}>
                                    <div>
                                        <span style={{fontWeight: "bold"}}>{dataList[2].gcDiscount*100}</span>%
                                    </div>
                                    <div style={{fontSize: ".3rem", fontWeight: "bold"}}>OFF</div>
                                </div>
                            </div>
                            <div className={styles.vip_label}>
                                <img style={{width: "0.5rem", verticalAlign: "text-top"}} src="/img/img_vip.webp" alt=""/>
                                <span>VIP +{dataList[2].vipExperience}</span>
                            </div>
                            <div className={`${styles.textarea} ${styles.third_textarea}`}>
                                <div className={styles.gc_text}>
                                    <img src="/img/ico_gc.png" style={{width: ".65rem"}} alt=""/>
                                    <span>GC</span>
                                    <span>{dataList[2].gc}</span>
                                </div>
                                <div className={styles.sc_text}>
                                    <span style={{color: "#fff", fontSize: ".6rem", marginLeft: "-0.2rem"}}>+</span>
                                    <img
                                        src="/img/ico_sc.png"
                                        style={{width: ".65rem", verticalAlign: "text-top", margin: "0 .1rem"}}
                                        alt=""
                                    />
                                    {dataList[2].extraScLimit === 0 ?
                                        <span>SC {dataList[2].sc}</span>
                                        :
                                        <span>SC {dataList[2].sc}-SC {dataList[2].sc + dataList[2].extraScLimit}</span>
                                    }
                                    {/*<span>SC</span>*/}
                                    {/*<span>6-SC 8</span>*/}
                                </div>
                                <div style={{padding: ".1rem"}}>
                                    <Button
                                        color="#33D24A"
                                        style={{
                                            color: "#fff",
                                            fontSize: ".6rem",
                                            width: "5.1rem",
                                            height: "1rem",
                                            fontWeight: "bold",
                                        }}
                                        onClick={() => handleStarterPackClick(dataList[2])}
                                    >
                                        Only ${dataList[2].money}
                                    </Button>
                                </div>
                            </div>
                        </section>
                    </section>}
                </section>
            </section>
        </SDialogFC>
    );
};
